// extracted by mini-css-extract-plugin
module.exports = {"textarea":"Textarea_textarea__xs_lA","default":"Textarea_default__btuY0","fullWidth":"Textarea_fullWidth__gqjjM","noResize":"Textarea_noResize__r9dJJ"};